import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import PageTitle from 'components/shared/page-title/page-title.component';
import ManageMillingMaterials from './milling-materials/mange-milling-materials.component';
import ManageMillingJobTypes from './milling-job-types/mange-milling-job-types.component';

const MillingJobSettings: FC = () => {
    const { t: translate } = useTranslation(['milling-jobs', 'orders']);

    return (
        <Fragment>
            <PageTitle headingStyle="h2" title={translate('milling-jobs:MILLING_JOBS')} />

            <Grid container>
                <Grid item sm={12} md={8}>
                    <PageTitle headingStyle="h3" title={translate('orders:MATERIALS')} />
                    <ManageMillingMaterials />

                    <PageTitle headingStyle="h3" title={translate('milling-jobs:JOB_TYPES')} />
                    <ManageMillingJobTypes />
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default MillingJobSettings;
